import Box from '@mui/material/Box';
import { Trans } from 'react-i18next';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import TaskAltIcon from '@mui/icons-material/TaskAltOutlined';

type Props = {
  open: boolean,
  handleClose: any,
  title: string,
  message: string
}

export default (props: Props) => {
  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      className="ticket-form-succes-dialog"
    >
      <Box>
        <Box sx={{margin: '0 9%'}}>
          <Box sx={{display: 'flex', margin: '32px 0 0'}}>
            <TaskAltIcon className="ticket-form-succes-dialog-icon" sx={{marginRight: '12px'}}/>
            <Box className="ticket-form-succes-dialog-title">{props.title}</Box>
          </Box>
        
          <Box className="ticket-form-succes-dialog-text" sx={{marginTop: '18px'}}>
            {`${props.message}`}
          </Box>
        
        </Box>
        <Box sx={{display: 'flex', justifyContent: 'space-around', margin: '12px 9%'}}>
          <Button onClick={props.handleClose} className="ticket-form-succes-dialog-success-button">
              <Trans i18nKey={`screens.createMaintenance.successDialogAcceptButton`}></Trans>
          </Button>
        </Box>
      </Box>
    </Dialog>
  )
}